module.exports = __webpack_public_path__ + "img/34_bohle.1819a248.jpeg";